module.exports = __webpack_public_path__ + "img/seed_logo.d3312f5c.png";